import { skipToken } from '@reduxjs/toolkit/query';
import { BenefitTypes } from '@strata/constants';
import { formatDate } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelList, DetailLabelValuePair } from '@strata/react-label-value-pairs';

import { NoAuthorizationNeededMessage } from 'components/shared/NoAuthorizationNeededMessage';
import { formatAuths } from 'services/referralHelpers';
import { useGetNeedsByDateQuery } from 'store/api/performanceApi';
import { ReferralDetails as ReferralDetailsInterface } from 'store/api/treatmentApi';

interface ReferralDetailsProps {
    showNeedsByDate: boolean;
    selectedReferral?: {
        referralExpiration: string;
    };
    referralDetails?: ReferralDetailsInterface;
}

export const ReferralDetails = ({
    showNeedsByDate,
    selectedReferral = undefined,
    referralDetails = undefined,
}: ReferralDetailsProps) => {
    const { data: needsByDate } = useGetNeedsByDateQuery(
        showNeedsByDate &&
            referralDetails?.treatmentId &&
            referralDetails.benefit === BenefitTypes.PHARMACY
            ? { treatmentId: referralDetails.treatmentId }
            : skipToken,
    );

    return (
        <FormSectionWithRows
            sectionTitle="Referral Details"
            width="50%"
            isLoading={!referralDetails}
            rowOneContent={
                <>
                    <DetailLabelValuePair
                        style={{ width: '50%' }}
                        label="Outreach Start Date"
                        value={formatDate(referralDetails?.outreachDate)}
                    />
                    <DetailLabelValuePair
                        style={{ width: '50%' }}
                        label="Referral Expiration"
                        value={formatDate(selectedReferral?.referralExpiration)}
                    />
                </>
            }
            rowTwoContent={
                <>
                    {showNeedsByDate && (
                        <DetailLabelValuePair
                            style={{ width: '50%' }}
                            label="Next Fill Needs By Date"
                            value={formatDate(needsByDate?.needsByDate)}
                        />
                    )}
                    <DetailLabelList
                        style={{ width: '50%' }}
                        label="Auth Period(s) (Auth ID)"
                        values={
                            (referralDetails?.auths ?? []).length > 0
                                ? formatAuths(referralDetails!.auths, true)
                                : [<NoAuthorizationNeededMessage key="no-authorization-needed" />]
                        }
                    />
                </>
            }
        />
    );
};
